import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Button from 'components/common/Button/Button'

const AddToQuoteButtonMobile = ({ handleClick, disabled, deviceType = 'mobile', ...props }) =>
  <CustomButton
    { ...props }
    narrow
    data-add-to-quote={ deviceType }
    disabled={ disabled }
    onClick={ handleClick }>+ Quote
  </CustomButton>

AddToQuoteButtonMobile.propTypes = {
  deviceType: PropTypes.string,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func
}

const CustomButton = styled(Button)`
  padding: 11px 12px 9px;
  width: 115px;
  ${Mixin.property('full', `
    width: 100%;
  `)}
`

export default AddToQuoteButtonMobile
